// Imports
import React, { Component } from 'react';
import { Link, Element, scroller } from 'react-scroll';
import { Grid, Cell } from 'react-mdl';
import { browserName, osName } from 'react-device-detect';

// Components
import Rocketship from './rocketship';

// CSS
import './../styles/css/home.css';

// const greetings = ['Hello', 'Hallo', 'Jambo', 'Barev dzez', 'Mingalarba', 'Chum reap suor', 'Ni hao', 'Namasté', 'Halo', 'Konnichiwa', 'Annyeonghaseyo', 'Sabaidee', 'Sain baina uu', 'Kumusta', 'Vanakkam', 'Sàwàtdee', 'Xin chào', 'Tungjatjeta', 'Zdravejte', 'Bok', 'Ahoj', 'Terve', 'Bonjour', 'Dia duit', 'Guten tag', 'Yasass', 'Szervusz', 'Halló', 'Salve', 'God dag', 'Cześć', 'Olá', 'Salut', 'Privét', 'Zdravo', 'Hola', 'Hej', 'Vitayu', 'As-salām ‘alaykum', 'Shalóm', 'Salâm', 'Merhaba', 'Aloha', 'Asalaam alaikum', 'Hei', 'Geia', 'Hai'];

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // greeting: 'Hello',
            instantRedirect: false,
        };
    }

    componentDidMount() {
        // this.interval = setInterval(() => this.updateGreeting(), 1500);
        scroller.scrollTo('home-heading', { duration: 0 });

        if (osName.includes('iOS') || browserName.includes('Safari') || browserName.includes('Firefox')) {
            this.setState({ instantRedirect: true });
        }
    }

    // componentWillUnmount() {
    //     clearInterval(this.interval);
    // }

    // updateGreeting() {
    //     this.setState({
    //         greeting: greetings[Math.floor(Math.random() * greetings.length)],
    //     });
    // }

    launchRocketship() {
        const rocketship = document.querySelector('.rocket');
        const exhaustFlames = document.querySelector('.exhaust-flame');

        rocketship.className += ' rocket-active';
        exhaustFlames.className += '-active';

        setTimeout(() => {
            rocketship.className = rocketship.className.replace(' rocket-active', '');
            exhaustFlames.className = exhaustFlames.className.replace('-active', '');
        }, 2500);
    }

    launchLink(link) {
        setTimeout(() => {
            window.open(link, '_blank');
        }, 1500);
    }

    checkForInstant(socialType) {
        if (socialType === 'resume') {
            if (this.state.instantRedirect) {
                return (
                    <a href='../resources/Resume (Ian Yang).pdf' rel="noopener noreferrer" target="_blank">
                        <img src='../images/resume.svg' alt="Resume" className="social-icon" />
                    </a>
                );
            } else {
                return (
                    <button className="link-button" onClick={this.launchRocketship}>
                        <button className="link-button" onClick={() => this.launchLink('../resources/Resume (Ian Yang).pdf')}>
                            <img src='../images/resume.svg' alt="Resume" className="social-icon" />
                        </button>
                    </button>

                );
            }
        } else if (socialType === 'github') {
            if (this.state.instantRedirect) {
                return (
                    <a href='https://github.com/ianyyang' rel="noopener noreferrer" target="_blank">
                        <img src='../images/github.svg' alt="GitHub" className="social-icon" />
                    </a>
                );
            } else {
                return (
                    <button className="link-button" onClick={this.launchRocketship}>
                        <button className="link-button" onClick={() => this.launchLink('https://github.com/ianyyang')}>
                            <img src='../images/github.svg' alt="GitHub" className="social-icon" />
                        </button>
                    </button>
                );
            }
        } else if (socialType === 'linkedin') {
            if (this.state.instantRedirect) {
                return (
                    <a href='https://www.linkedin.com/in/ianyyang/' rel="noopener noreferrer" target="_blank">
                        <img src='../images/linkedin.svg' alt="LinkedIn" className="social-icon" />
                    </a>
                );
            } else {
                return (
                    <button className="link-button" onClick={this.launchRocketship}>
                        <button className="link-button" onClick={() => this.launchLink('https://www.linkedin.com/in/ianyyang/')}>
                            <img src='../images/linkedin.svg' alt="LinkedIn" className="social-icon" />
                        </button>
                    </button>
                );
            }
        } else if (socialType === 'email') {
            if (this.state.instantRedirect) {
                return (
                    <a href='mailto:ianyyang00@gmail.com' rel="noopener noreferrer" target="_blank">
                        <img src='../images/email.svg' alt="Email" className="social-icon" />
                    </a>
                );
            } else {
                return (
                    <button className="link-button" onClick={this.launchRocketship}>
                        <button className="link-button" onClick={() => this.launchLink('mailto:ianyyang00@gmail.com')}>
                            <img src='../images/email.svg' alt="Email" className="social-icon" />
                        </button>
                    </button>
                );
            }
        }
    }

    render() {
        return (
            <div className="home">
                <Grid>
                    <Cell col={12}>
                        <div className="home-grid">
                            <Element name="home-heading">
                                <div className="banner-text">
                                    <h1><span>I&apos;m Ian Yang!</span></h1>
                                    <p>
                                        Software Engineer @ Faire
                                    </p>
                                    {/* <hr /> */}
                                </div>
                            </Element>

                            <div className="social-links">
                                {/* Resume */}
                                <div className="social-icon">
                                    {this.checkForInstant('resume')}
                                    <p className="social-icon-caption">Resume</p>
                                </div>

                                {/* Projects */}
                                <div className="social-icon">
                                    {/* eslint-disable-next-line */}
                                    <Link
                                        activeClass="active"
                                        to="projects-grid"
                                        smooth={true}
                                        delay={0}
                                        offset={-1000}
                                        duration={2500}
                                    >
                                        <button className="link-button" onClick={this.launchRocketship}>
                                            <img src='../images/projects.svg' alt="Projects" className="social-icon" />
                                        </button>
                                    </Link>
                                    <p className="social-icon-caption">Projects</p>
                                </div>

                                {/* GitHub */}
                                <div className="social-icon">
                                    {this.checkForInstant('github')}
                                    <p className="social-icon-caption">GitHub</p>
                                </div>

                                {/* LinkedIn */}
                                <div className="social-icon">
                                    {this.checkForInstant('linkedin')}
                                    <p className="social-icon-caption">LinkedIn</p>
                                </div>

                                {/* Email */}
                                <div className="social-icon">
                                    {this.checkForInstant('email')}
                                    <p className="social-icon-caption">Email</p>
                                </div>
                            </div>
                        </div>

                        <Rocketship />
                    </Cell>
                </Grid>
            </div>
        );
    }
}

export default Home;
